export class DeviceProperty{
    choiceValues:string[];
    constructor(
        public name?:string,
        public dataType?:string,
        public storageName?:string
    ){
        this.choiceValues = this.isChoice() ? dataType.substring(7, dataType.length - 1).split('|') : [];
    }
    isInteger():boolean{
        return this.dataType == "INTEGER";
    }
    isChoice():boolean{
        return this.dataType.indexOf('CHOICE') != -1;
    }
}

export class DeviceSetting{
    constructor(public model:string,
                public deviceProperties:DeviceProperty[],
                public defaultNetworkSettings:string,
                public defaultPropertyValues:string,
                public enablePhysicalID:boolean){
    }
}

export class DevicePropertyValue{
    value:any = "";
    name:string;
    storageName:string;
    show:boolean = false;
    constructor(public deviceProperty:DeviceProperty){
        this.name = deviceProperty.name;
        this.storageName = deviceProperty.storageName;
    }
    setValue(nameValues:string){
        if (nameValues == null)
            return;
        var nameValuesArr = nameValues.split("|");
        for (var i = 0; i < nameValuesArr.length; i++) {
            var nameVal = nameValuesArr[i];
            var nameValueArr = nameVal.split("=");
            if (nameValueArr.length != 2)
                return;
            var name = nameValueArr[0];
            var value = nameValueArr[1];
            if (this.storageName == name) {
                if (this.deviceProperty.isInteger())
                    this.value = Number.isNaN(parseInt(value)) ? "" : parseInt(value);
                else
                    this.value = value;
            }
        }
    }
}
